import { useContext, useMemo } from 'react'
import { ToastContext } from './toastContext'

/**
 * Use inside any component under <ToastProvider>:
 *   const toast = useToast()
 *   toast.success('Saved')
 *   toast.errorFrom(err, 'Refund failed')
 */
export function useToast() {
  const ctx = useContext(ToastContext)
  if (!ctx) {
    throw new Error('useToast must be used inside <ToastProvider>')
  }
  return useMemo(
    () => ({
      show: ctx.show,
      info: (msg: string) => ctx.show(msg, 'info'),
      success: (msg: string) => ctx.show(msg, 'success'),
      warning: (msg: string) => ctx.show(msg, 'warning'),
      error: (msg: string) => ctx.show(msg, 'error'),
      /** Extract a useful message from an axios-style error. */
      errorFrom: (err: any, fallback = 'Something went wrong') => {
        const message =
          err?.response?.data?.message ||
          err?.response?.data?.error?.message ||
          err?.message ||
          fallback
        ctx.show(message, 'error')
      },
    }),
    [ctx]
  )
}
